import React, { useState } from "react";
import header_logo from "../../assets/hospital_logo.svg"
import DownArrow from "../../assets/down-arrow.png"
import { Link } from "react-scroll"
import "./header.css"
import { useMediaQuery } from 'react-responsive'
function Header() {
  const [menu, setMenu] = useState('menu')
  const [link, setLink] = useState('navbar_links')
  const [nav, setNav] = useState('')
  const myFunction = () => {
    if (menu === 'menu') {
      setMenu('menu change')
      setLink('navbar_links navbar_links_responsive')
      setNav('nav_reponsive')
    } else {
      setMenu('menu')
      setLink('navbar_links')
      setNav('')
    }
  }
  const isMobile = useMediaQuery({ query: '(max-width: 450px)' })
  return (
    <>
      <nav className={nav}>
        <div className="logo_content">
          <img src={header_logo} alt="logo" />
          <span>ENT Care Clinic</span>
        </div>
        <div className={link}>
          {// eslint-disable-next-line
          }<a target="_blank" href="#"><Link to="about" spy={true} smooth={true} style={{ cursor: 'pointer' }} offset={-120}>About</Link></a>
          {// eslint-disable-next-line
          }<a target="_blank" href='#'><Link to="video" spy={true} smooth={true} style={{ cursor: 'pointer' }} offset={-120}>Video</Link></a>
          {// eslint-disable-next-line
          }<a target="_blank" href='#'><Link to="reviews" spy={true} smooth={true} style={{ cursor: 'pointer' }} offset={-120}>Reviews</Link></a>
          {/*<a href="/"><Link to="contact" spy={true} smooth={true} style={{ cursor: 'pointer' }} offset={-120}>Contact</Link></a> */}
          <button onClick={() => { window.open("https://api.whatsapp.com/send/?phone=918707699762&text=9999202000%20press%20send%20to%20book%20appointment%20with%20Dr.%20Aashima%20%F0%9F%91%89") }}>Book appointment</button>
        </div>
        <div class={menu} onClick={myFunction}>
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </nav>
      <div className="header" id="home">
        <div className="header_info">
          <div className="doc_name">
            <h1><span style={{ color: "#F8C28F" }}>Dr. Aashima Chopra</span></h1>
            <h2>ENT(otorhinolaryngology)</h2>
          </div>
          {isMobile ? (<div className="doc_info">
            <div className="expertize">
              <h1>8</h1>
              <p>Years</p>
              <p>of experience</p>
            </div>
            <div className="no_reviews">
              <h1>80K+</h1>
              <p>Patients</p>
              <p>Consulted</p>
            </div>
            <div className="test_done">
              <h1>Gold</h1>
              <p>Gold</p>
              <p>Medalist</p>
              <p></p>
            </div>
          </div>) : (<div className="doc_info">
            <div className="expertize">
              <h1>8</h1>
              <p>Years of experience</p>
            </div>
            <div className="no_reviews">
              <h1>80K+</h1>
              <p>Patients consulted</p>
            </div>
            <div className="test_done">
              <h1>Gold</h1>
              <p>Gold medalist</p>
            </div>
          </div>)}
        </div>
        <Link to="about" spy={true} smooth={true} style={{ cursor: 'pointer' }} offset={-80}>
          <img src={DownArrow} style={{ width: "3rem", height: "auto", marginTop: "5vh" }} alt="DownArrow" />
        </Link>
      </div>
    </>
  );
}

export default Header;
